// ./src/contexts/PurchaseOrdersContext/PurchaseOrdersContext.tsx
//
// Thin context wrapper around the usePurchaseOrders hook. All derived data lives
// in the hook. Mounted on the account Purchase Orders page and (with an eventId)
// on an event's Inventory pages.

import React, { createContext, useContext } from "react";

import { usePurchaseOrders, UsePurchaseOrdersOptions, UsePurchaseOrdersReturn } from "@/hooks/usePurchaseOrders";

const PurchaseOrdersContext = createContext<UsePurchaseOrdersReturn | null>(null);

export interface PurchaseOrdersProviderProps extends UsePurchaseOrdersOptions {
  children: React.ReactNode;
}

export const PurchaseOrdersProvider: React.FC<PurchaseOrdersProviderProps> = ({ children, ...options }) => {
  const value = usePurchaseOrders(options);

  return <PurchaseOrdersContext.Provider value={value}>{children}</PurchaseOrdersContext.Provider>;
};

export const usePurchaseOrdersContext = (): UsePurchaseOrdersReturn => {
  const context = useContext(PurchaseOrdersContext);

  if (!context) {
    throw new Error(
      "usePurchaseOrdersContext must be used within a <PurchaseOrdersProvider>. " +
        "Wrap your component tree with <PurchaseOrdersProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalPurchaseOrdersContext = (): UsePurchaseOrdersReturn | null => {
  return useContext(PurchaseOrdersContext);
};
